(() => {
  const root = document.body.dataset.routeRoot || '/';
  const endpoint = path => root.replace(/\/$/, '') + '/' + path;
  const feedback = document.querySelector('.s-cart-feedback');
  let feedbackTimer;
  const report = message => {
    if (!feedback) return;
    feedback.querySelector('[data-cart-feedback]').textContent = message;
    feedback.hidden = false;
    clearTimeout(feedbackTimer);
    feedbackTimer = setTimeout(() => { feedback.hidden = true; }, 9000);
  };
  document.querySelector('[data-close-feedback]')?.addEventListener('click', () => { feedback.hidden = true; });
  document.querySelectorAll('.s-quick-add,.s-product-form').forEach(form => {
    form.addEventListener('submit', async event => {
      event.preventDefault();
      const button = form.querySelector('button[type="submit"]');
      const status = form.querySelector('.s-status');
      const label = button.innerHTML;
      button.disabled = true;
      form.dataset.submitting = 'true';
      button.textContent = 'Adding…';
      button.setAttribute('aria-busy', 'true');
      if (status) status.textContent = '';
      try {
        const response = await fetch(endpoint('cart/add.js'), { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form) });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || result.message || 'Unable to add this item. Please try again.');
        const cartResponse = await fetch(endpoint('cart.js'), { headers: { 'Accept': 'application/json' } });
        if (cartResponse.ok) {
          const cart = await cartResponse.json();
          document.querySelectorAll('.s-cart-count').forEach(node => { node.textContent = cart.item_count; });
        }
        if (status) status.textContent = 'Added to your cart.';
        report(`${result.product_title || result.title || 'Item'} added to your cart.`);
      } catch (error) {
        if (status) status.textContent = error.message;
        else report(error.message);
      } finally {
        form.dataset.submitting = 'false';
        button.disabled = form.dataset.variantAvailable === 'false';
        button.innerHTML = label;
        button.removeAttribute('aria-busy');
        form.dispatchEvent(new Event('serray:cart-settled'));
      }
    });
  });
  document.querySelectorAll('[data-quantity-minus],[data-quantity-plus]').forEach(button => {
    button.addEventListener('click', () => {
      const input = button.closest('.s-quantity').querySelector('input');
      const current = Number(input.value) || 0;
      const delta = button.hasAttribute('data-quantity-plus') ? 1 : -1;
      input.value = Math.max(Number(input.min) || 0, current + delta);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });
  document.querySelectorAll('.mn-pdp-benefits').forEach(section => {
    const track = section.querySelector('[data-benefit-track]');
    const previous = section.querySelector('[data-benefit-previous]');
    const next = section.querySelector('[data-benefit-next]');
    if (!track || !previous || !next) return;
    const update = () => {
      const position = Math.abs(track.scrollLeft);
      previous.disabled = position < 2;
      next.disabled = position >= track.scrollWidth - track.clientWidth - 2;
    };
    const move = direction => {
      const card = track.querySelector('.mn-benefit-card');
      const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      const step = (card?.getBoundingClientRect().width || track.clientWidth) + gap;
      const rtl = getComputedStyle(track).direction === 'rtl' ? -1 : 1;
      track.scrollBy({left: direction * rtl * step, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
    };
    previous.addEventListener('click', () => move(-1));
    next.addEventListener('click', () => move(1));
    track.addEventListener('scroll', update, {passive: true});
    if (window.ResizeObserver) new ResizeObserver(update).observe(track);
    update();
  });
  document.querySelectorAll('[data-auto-submit]').forEach(select => select.addEventListener('change', () => select.form.requestSubmit()));
  document.querySelectorAll('[data-product-section]').forEach(section => {
    const variants = JSON.parse(section.querySelector('[data-product-variants]').textContent);
    const select = section.querySelector('[data-variant-select]');
    const plan = section.querySelector('[data-selling-plan]');
    const form = section.querySelector('.s-product-form');
    const thumbnails = [...section.querySelectorAll('[data-gallery-src]')];
    const showMedia = (mediaId, fallbackImage) => {
      const gallery = section.querySelector('[data-main-gallery]');
      const template = [...section.querySelectorAll('[data-product-media]')].find(item => Number(item.dataset.productMedia) === Number(mediaId));
      gallery.querySelectorAll('video').forEach(video => video.pause());
      if (template) gallery.replaceChildren(template.content.cloneNode(true));
      else {
        const image = gallery.querySelector('img');
        if (fallbackImage && image) { image.removeAttribute('srcset'); image.src = fallbackImage; }
      }
      thumbnails.forEach(button => button.setAttribute('aria-pressed', String(Number(button.dataset.mediaId) === Number(mediaId))));
      const index = thumbnails.findIndex(button => Number(button.dataset.mediaId) === Number(mediaId));
      const status = section.querySelector('[data-gallery-status]');
      if (status && index >= 0) status.textContent = 'Image ' + (index + 1) + ' of ' + thumbnails.length;
    };
    const update = () => {
      const id = Number(form.querySelector('[name="id"]').value);
      const variant = variants.find(item => item.id === id);
      if (!variant) return;
      section.querySelector('[data-variant-sku]').textContent = variant.sku || '—';
      section.querySelector('[data-variant-stock]').textContent = variant.available ? 'Available' : 'Sold out';
      let allocation;
      if (plan) {
        for (const option of plan.options) {
          if (!option.value) continue;
          option.disabled = !variant.allocations.some(item => String(item.id) === option.value);
        }
        allocation = variant.allocations.find(item => String(item.id) === plan.value);
        if (plan.value && !allocation) { plan.value = ''; }
      }
      const allowed = variant.available && (!section.dataset.requiresSellingPlan || Boolean(plan?.value));
      const price = section.querySelector('[data-variant-price]');
      price.replaceChildren(document.createTextNode(allocation?.price_formatted || variant.price_formatted));
      if (!allocation && variant.compare_price > variant.price) {
        const compare = document.createElement('s'); compare.textContent = variant.compare_price_formatted;
        price.append(document.createTextNode(' '), compare);
      }
      const button = section.querySelector('[data-product-submit]');
      form.dataset.variantAvailable = String(allowed);
      button.disabled = !allowed || form.dataset.submitting === 'true';
      if (form.dataset.submitting === 'true') return;
      const arrow = button.querySelector('img');
      button.replaceChildren(document.createTextNode(variant.available ? 'Add to cart ' : 'Sold out'));
      if (variant.available && arrow) button.append(arrow);
      if (variant.media_id || variant.image) showMedia(variant.media_id, variant.image);
      if (select) {
        const url = new URL(location.href);
        url.searchParams.set('variant', variant.id);
        history.replaceState({}, '', url);
      }
    };
    select?.addEventListener('change', update);
    plan?.addEventListener('change', update);
    form.addEventListener('serray:cart-settled', update);
    section.querySelectorAll('[data-gallery-src]').forEach(button => button.addEventListener('click', () => {
      if (button.dataset.mediaId) showMedia(button.dataset.mediaId, button.dataset.gallerySrc);
      else {
        const img = section.querySelector('[data-main-gallery] img');
        if (!img) return;
        img.removeAttribute('srcset'); img.src = button.dataset.gallerySrc;
        img.alt = button.querySelector('img')?.alt || section.querySelector('h1')?.textContent.trim() || '';
        section.querySelectorAll('[data-gallery-src]').forEach(other => other.setAttribute('aria-pressed', String(other === button)));
      }
    }));
  });
  document.querySelectorAll('details.s-categories-menu,details.s-mobile-nav,details.s-filter-details').forEach(menu => {
    menu.addEventListener('keydown', event => { if (event.key === 'Escape') { menu.open = false; menu.querySelector('summary').focus(); } });
    document.addEventListener('click', event => { if (!menu.contains(event.target)) menu.open = false; });
  });
  const nativePolicy = document.querySelector('.shopify-policy__container');
  if (nativePolicy) {
    nativePolicy.classList.add('s-native-policy');
    const body = nativePolicy.querySelector('.shopify-policy__body');
    body.classList.add('s-prose'); body.setAttribute('data-policy-content', '');
    const sidebar = document.createElement('nav'); sidebar.className = 's-policy-toc'; sidebar.setAttribute('aria-label', 'Page contents');
    const title = document.createElement('strong'); title.textContent = 'On this page';
    const contents = document.createElement('div'); contents.setAttribute('data-page-toc', '');
    const contact = document.createElement('a'); contact.href = '/pages/contact-us'; contact.textContent = 'Need help? Contact us';
    sidebar.append(title, contents, contact); nativePolicy.insertBefore(sidebar, body);
  }
  const policy = document.querySelector('[data-policy-content]');
  // Imported WordPress headings belong below the page's single H1.
  policy?.querySelectorAll('h1').forEach(heading => {
    const replacement = document.createElement('h2');
    for (const attribute of heading.attributes) replacement.setAttribute(attribute.name, attribute.value);
    replacement.append(...heading.childNodes);
    heading.replaceWith(replacement);
  });
  document.querySelectorAll('[data-name="Navigation links"] a,.s-mobile-nav nav a').forEach(link => {
    const target = new URL(link.href);
    if (target.pathname === location.pathname && target.searchParams.get('view') === new URL(location.href).searchParams.get('view')) link.setAttribute('aria-current', 'page');
  });
  const hero = document.querySelector('[data-hero-slides]');
  if (hero) {
    const slides = JSON.parse(hero.textContent);
    const image = document.querySelector('.s-carousel-image');
    const count = document.querySelector('[data-slide-count]');
    let current = 0;
    document.querySelectorAll('[data-carousel-action]').forEach(button => button.addEventListener('click', () => {
      current = (current + (button.dataset.carouselAction === 'next' ? 1 : -1) + slides.length) % slides.length;
      image.src = slides[current].src;
      count.textContent = `${String(current + 1).padStart(2, '0')} / ${String(slides.length).padStart(2, '0')}`;
    }));
  }
  const toc = document.querySelector('[data-page-toc]');
  if (policy && toc) {
    policy.querySelectorAll('h2,h3').forEach((heading, index) => {
      heading.id ||= `policy-section-${index + 1}`;
      const a = document.createElement('a'); a.href = '#' + heading.id; a.textContent = heading.textContent; toc.append(a);
    });
    if (!toc.children.length) { toc.textContent = 'Policy information'; }
  }
})();
